import script from "./AdminNoticeDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminNoticeDetail.vue?vue&type=script&setup=true&lang=ts"

import "./AdminNoticeDetail.vue?vue&type=style&index=0&id=45ed1300&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ed1300"]])

export default __exports__